/*eslint-disable*/
import api from './'

class ConfirmationApi {
    static list(params, cancelToken = null) {
        return api.axios.get('/confirmation', {params, cancelToken})
            .then(response => response.data.confirmations)
    }

    static update(id, request) {
        return api.axios.put('/confirmation/' + id, request)
            .then(response => response.data)
    }
}

export default ConfirmationApi;
